import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import { CouponApiResponseSuccess, CouponApiResponseError, getCoupon, getInfluencerByCoupon } from "./actions";

// constants
import { CouponActionTypes } from "./constants";
import {
  addCouponsApi,
  deleteCouponsApi,
  getCouponsApi,
  updateCouponsApi,
  getCouponsReportApi,
  getInfluencerCouponsApi,
} from "../../helpers/api/coupons";

interface CouponsData {
  payload: {
    id: string;
    coupon_code: string;
    expire_in: string;
    start_in: string;
    is_active: boolean;
    max_apply_limit: string;
    coupon_percentage: string;
    commision_percentage: string;
    influencer: number;
  };
  type: string;
}

function* createCoupons({
  payload: { coupon_code, expire_in, start_in, max_apply_limit, coupon_percentage, commision_percentage, influencer },
  type,
}: CouponsData): SagaIterator {
  try {
    const response = yield call(addCouponsApi, {
      coupon_code,
      expire_in,
      start_in,
      max_apply_limit,
      coupon_percentage,
      commision_percentage,
      influencer,
    });

    const CouponsData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(CouponApiResponseSuccess(CouponActionTypes.CREATE_COUPONS, CouponsData));
    yield put(getInfluencerByCoupon(influencer));
  } catch (error: any) {
    

    yield put(CouponApiResponseError(CouponActionTypes.CREATE_COUPONS, error));
  }
}

function* updateCoupons({
  payload: { id, coupon_code, expire_in, start_in, max_apply_limit, coupon_percentage, commision_percentage, influencer },
}: CouponsData): SagaIterator {
  try {
    const response = yield call(updateCouponsApi, id, {
      coupon_code,
      expire_in,
      start_in,
      max_apply_limit,
      coupon_percentage,
      commision_percentage,
      influencer,
    });
    const CouponsData = response.data.message;

    yield put(CouponApiResponseSuccess(CouponActionTypes.UPDATE_COUPONS, CouponsData));
    yield put(getInfluencerByCoupon(influencer));
  } catch (error: any) {
    yield put(CouponApiResponseError(CouponActionTypes.UPDATE_COUPONS, error));
  }
}

function* getCoupons(): SagaIterator {
  try {
    const response = yield call(getCouponsApi);
    const CouponsData = response?.data;

    yield put(CouponApiResponseSuccess(CouponActionTypes.GET_COUPONS, CouponsData));
  } catch (error: any) {
    yield put(CouponApiResponseError(CouponActionTypes.GET_COUPONS, error));
  }
}

function* getInfluencerCoupons({ payload: { influencer } }: CouponsData): SagaIterator {
  try {
    const response = yield call(getInfluencerCouponsApi, influencer);
    const CouponsData = response?.data;

    yield put(CouponApiResponseSuccess(CouponActionTypes.GET_COUPONS_INFLUENCERS, CouponsData));
  } catch (error: any) {
    yield put(CouponApiResponseError(CouponActionTypes.GET_COUPONS_INFLUENCERS, error));
  }
}

function* deleteCoupons({ payload: { id, influencer } }: CouponsData): SagaIterator {
  try {
    const response = yield call(deleteCouponsApi, id);
    const CouponsData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(CouponApiResponseSuccess(CouponActionTypes.DELETE_COUPONS, CouponsData));
    yield put(getInfluencerByCoupon(influencer));
  } catch (error: any) {
    yield put(CouponApiResponseError(CouponActionTypes.DELETE_COUPONS, error));
  }
}

function* getReportsCoupons({ payload: { type, from, to } }: any): SagaIterator {
  try {
    const response = yield call(getCouponsReportApi, type, from, to);
    const CouponsData = response?.data;

    yield put(CouponApiResponseSuccess(CouponActionTypes.GET_COUPONS_REPORT, CouponsData));
  } catch (error: any) {
    yield put(CouponApiResponseError(CouponActionTypes.GET_COUPONS_REPORT, error));
  }
}

export function* watchCreateCoupons() {
  yield takeEvery(CouponActionTypes.CREATE_COUPONS, createCoupons);
}
export function* watchUpdateCoupons() {
  yield takeEvery(CouponActionTypes.UPDATE_COUPONS, updateCoupons);
}
export function* watchgetCoupon() {
  yield takeEvery(CouponActionTypes.GET_COUPONS, getCoupons);
}

export function* watchgetInfluencerCoupon() {
  yield takeEvery(CouponActionTypes.GET_COUPONS_INFLUENCERS, getInfluencerCoupons);
}

export function* watchgetCouponReport() {
  yield takeEvery(CouponActionTypes.GET_COUPONS_REPORT, getReportsCoupons);
}

export function* watchDeleteCoupons() {
  yield takeEvery(CouponActionTypes.DELETE_COUPONS, deleteCoupons);
}

function* CouponsSaga() {
  yield all([
    fork(watchCreateCoupons),
    fork(watchUpdateCoupons),
    fork(watchDeleteCoupons),
    fork(watchgetCoupon),
    fork(watchgetCouponReport),
    fork(watchgetInfluencerCoupon),
  ]);
}

export default CouponsSaga;
